const containsOnlyContactLensesSubscriptionLineItems = (lineItems)=>{
    return lineItems.every((lineItem)=>lineItem.type === 'contact-lenses-subscription'
    );
};

export { containsOnlyContactLensesSubscriptionLineItems };
//# sourceMappingURL=contains-only-contact-lenses-subscription-line-items.js.map
